module.exports = "<router-outlet></router-outlet>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 1062
// module chunks = 0